import culture from '../culture';
import SyncFilter from '../Filters/SyncFilter';
import RadioGroup from './RadioGroup';

const isHu = culture.getBool();
const moreButtonName = [isHu ? 'Kevesebb' : 'Less', isHu ? 'Több' : 'More'];

export default class CatGroupManager {
    constructor(selector, moreSelector, courseFilter) {
        this.categoryRadioGroup = document.querySelector('#CategoryRadioGroup');
        if (!this.categoryRadioGroup) return;

        this.categorySync = new SyncFilter(courseFilter.filters.cat, new RadioGroup(this.categoryRadioGroup, true, true));

        let fixExtra = null;
        this.extras = Array.from(this.categoryRadioGroup.querySelectorAll('[data-extra]'))
            .reduce((acc, el) => {
                const id = el.tagName === 'INPUT' ? el.id : el.getAttribute('for');
                let extra = acc.find((e) => e.id === id);
                if (!extra) {
                    extra = { id, input: null, label: null };
                    acc.push(extra);
                }
                if (el.tagName === 'INPUT') {
                    if (el.checked) {
                        fixExtra = id;
                    }
                    extra.input = el;
                } else {
                    extra.label = el;
                }
                return acc;
            }, []);

        if (!this.extras.length) return;
        if (fixExtra) {
            this.extras.find((ex) => ex.id === fixExtra).label.hidden = false;
        }

        this.moreButton = this.categoryRadioGroup.querySelector(moreSelector);
        this.moreButtonLabel = this.moreButton.nextElementSibling;
        this.moreButton.addEventListener('change', (e) => {
            this.handleMoreButtonClick(!e.target.checked);
        });
    }

    handleMoreButtonClick(hidden) {
        this.moreButtonLabel.innerHTML = `${moreButtonName[hidden ? 1 : 0]}<i class="icon"></i>`;

        this.extras.forEach(({ input, label }) => {
            if (input && label && input.checked) {
                label.hidden = false;
            } else if (label) {
                label.hidden = hidden;
            }
        });
    }
}
